var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trophy",
    d: "M20.121,21.333C28.881,21.285,32,16.645,32,12.667a4.667,4.667,0,0,0-3.685-4.559c.181-.516.339-.989.444-1.348a5.183,5.183,0,0,0-.835-4.611A5.305,5.305,0,0,0,23.639,0H8.361A5.305,5.305,0,0,0,4.076,2.149,5.183,5.183,0,0,0,3.241,6.76c.105.359.267.832.444,1.348A4.667,4.667,0,0,0,0,12.667c0,3.979,3.119,8.619,11.879,8.667A6.747,6.747,0,0,1,12,22.561v4.105a2.511,2.511,0,0,1-2.667,2.667H8A1.333,1.333,0,1,0,8,32H24a1.333,1.333,0,0,0,0-2.667H22.677A2.513,2.513,0,0,1,20,26.667V22.56a6.744,6.744,0,0,1,.121-1.227Zm7.212-10.667a2,2,0,0,1,2,2c0,2.712-2.145,5.6-8.048,5.96A6.463,6.463,0,0,1,22.3,17.532a20.176,20.176,0,0,0,4.969-6.879C27.292,10.655,27.311,10.667,27.333,10.667Zm-24.667,2a2,2,0,0,1,2-2c.023,0,.041-.012.063-.013A20.176,20.176,0,0,0,9.7,17.532a6.463,6.463,0,0,1,1.016,1.095C4.812,18.267,2.667,15.379,2.667,12.667ZM14.017,29.333a5.44,5.44,0,0,0,.649-2.667V22.561a9.24,9.24,0,0,0-3.241-7.06A20.451,20.451,0,0,1,5.8,6a2.533,2.533,0,0,1,.413-2.259A2.659,2.659,0,0,1,8.361,2.667H23.639a2.659,2.659,0,0,1,2.149,1.08A2.533,2.533,0,0,1,26.2,6.005a20.451,20.451,0,0,1-5.627,9.5,9.237,9.237,0,0,0-3.241,7.059v4.107a5.44,5.44,0,0,0,.649,2.667Z",
    transform: "translate(0 0)",
    fill: "#F89E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.311d16d0e96c03719c56209b9f5d4982.svg";
export { ForwardRef as ReactComponent };